import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import RawImage from 'components/RawImage';
import { loadProviderByID as loadProviderByIdAction } from 'redux/modules/tve';
import classNames from 'classnames';

import './styles.themed.scss';

const block = 'tve-provider';

/**
 * Maps the state to props for the Logo component
 * @param {object} state The current state of the Redux store.
 * @param {object} state.shared The shared state.
 * @param {object} state.tve The tve state
 * @returns {object} the mapped props
 */
const mapStateToProps = ({ shared, tve }) => ({
  hasTempPass: tve.hasTempPass,
  provider: tve.provider,
  selected: tve.selected,
  vertical: shared.vertical,
});

/**
 * Maps the dispatch to props for the Logo component
 * @param {*} dispatch The current dispatch
 * @returns {object} The mapped props
 */
const mapDispatchToProps = (dispatch) => ({
  loadProviderById: (vertical, provider) => dispatch(loadProviderByIdAction(vertical, provider)),
});

/**
* @param {object} props The props object
* @param {boolean} props.hasTempPass
* @param {string} props.provider
* @param {object} props.selected
* @param {boolean} props.useColorLogo
* @param {boolean} props.inheritHeight
* @param {string} props.vertical
* @param {Function} props.loadProviderById
*/
const Logo = ({
  hasTempPass,
  provider,
  selected,
  useColorLogo,
  inheritHeight,
  vertical,
  loadProviderById,
}) => {
  const prevProvRef = useRef();

  /**
   * load provider if provider exists
   */
  const loadProvider = () => {
    if (provider) {
      loadProviderById(vertical, provider);
    }
  };

  useEffect(() => {
    if (!prevProvRef.current && provider) {
      loadProvider();
    }
    prevProvRef.current = provider;
  }, [provider]);

  if (hasTempPass || !provider) {
    return null;
  }

  const logoToUse = useColorLogo ? 'logoColor' : 'logo2xWhite';

  if (selected && typeof selected[logoToUse] !== 'undefined') {
    return (
      <div className={classNames(`${block}`, inheritHeight ? '' : `${block}-base`)}>
        <RawImage src={selected[logoToUse]} />
      </div>
    );
  }
  return provider;
};

export default connect(mapStateToProps, mapDispatchToProps)(Logo);
